import { render, staticRenderFns } from "./exports.vue?vue&type=template&id=681152d8&"
import script from "./exports.vue?vue&type=script&lang=js&"
export * from "./exports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports